module.exports = __webpack_public_path__ + "img/wenjuan_verify_process.28fde42.png";